import type PptxGenJS from 'pptxgenjs'
import { ROCKET_STANDARD_SLIDES } from '@/components/Deals/ProposalStudio/rocketStandardSlides'

const SLIDE_W = 13.333
const SLIDE_H = 7.5

async function readImageDataUrl(url: string): Promise<string> {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Não foi possível carregar o slide ${url}`)
  }
  const bytes = new Uint8Array(await (await response.blob()).arrayBuffer())
  let binary = ''
  const chunk = 8192
  for (let index = 0; index < bytes.length; index += chunk) {
    binary += String.fromCharCode(...bytes.subarray(index, index + chunk))
  }
  return `data:image/jpeg;base64,${btoa(binary)}`
}

/** Páginas reais da apresentação Rocket, na ordem do deck, antes do slide de investimento. */
export async function appendRocketStandardSlides(pptx: PptxGenJS): Promise<void> {
  for (const slideDef of ROCKET_STANDARD_SLIDES) {
    const data = await readImageDataUrl(slideDef.image)
    const slide = pptx.addSlide()
    slide.addImage({ data, x: 0, y: 0, w: SLIDE_W, h: SLIDE_H })
  }
}
